import { koComponent } from '../ko-utils';
import createUUID from '../utils/uuid';

class ColorPicker {
    constructor(params) {
        this.id = createUUID();

        this.value = params.value;
        this.title = params.title;
        this.colorMode = params.colorMode;

        this.hasGradient = ko.pureComputed(() => {
            return this.value() && this.value().indexOf('gradient') !== -1;
        });
    }
}

export default koComponent('color-picker', ColorPicker);